import React, { useState, useEffect } from 'react';
import { jsPDF } from 'jspdf';
import axiosInstance from "../../api/axiosConfig.jsx";
import 'bootstrap/dist/css/bootstrap.min.css';

const OfferteGenerator1 = () => {
    const [offerteData, setOfferteData] = useState({
        bedrijfsnaam: '',
        contactpersoon: '',
        email: '',
        telefoon: '',
        datum: '',
        begintijd: '',
        eindtijd: '',
        aantalPersonen: '',
        arrangementen: [{ type: 'lunch', optie: null }],
        extraWensen: '',
        locatie: 'binnen',
        dietaryWensen: [],
        extraServices: [],
        logoData: '',
        opmerkingen: ''
    });

    useEffect(() => {
        const fetchLogo = async () => {
            try {
                const token = sessionStorage.getItem('authToken');
                if (!token) {
                    throw new Error('Geen authToken gevonden');
                }

                const tokenPayload = JSON.parse(atob(token.split('.')[1]));
                const companyId = tokenPayload.companyId;

                const response = await axiosInstance.get(`/company-logos/${companyId}`);
                if (response.status === 200) {
                    setOfferteData(prev => ({
                        ...prev,
                        logoData: response.data.logoData
                    }));
                } else {
                    console.error('Logo niet gevonden');
                    setOfferteData(prev => ({
                        ...prev,
                        logoData: ''
                    }));
                }
            } catch (error) {
                console.error('Fout bij het ophalen van het logo:', error);
                setOfferteData(prev => ({
                    ...prev,
                    logoData: ''
                }));
            }
        };

        fetchLogo();
    }, []);

    const [prijslijst, setPrijslijst] = useState({
        lunch: {
            naam: 'Lunch arrangement',
            prijs: 17.50,
            opties: [
                { naam: 'Basis lunch', prijs: 17.50 },
                { naam: 'Uitgebreide lunch', prijs: 22.50 },
                { naam: 'Luxe lunch', prijs: 27.50 }
            ]
        },
        diner: {
            naam: 'Diner arrangement',
            prijs: 32.50,
            opties: [
                { naam: '3-gangen menu', prijs: 32.50 },
                { naam: '4-gangen menu', prijs: 42.50 },
                { naam: '5-gangen menu', prijs: 52.50 }
            ]
        },
        borrel: {
            naam: 'Borrel arrangement',
            prijs: 22.50,
            opties: [
                { naam: 'Basis borrel', prijs: 22.50 },
                { naam: 'Luxe borrel', prijs: 27.50 },
                { naam: 'Premium borrel', prijs: 32.50 }
            ]
        },
        buffet: {
            naam: 'Buffet arrangement',
            prijs: 27.50,
            opties: [
                { naam: 'Standaard buffet', prijs: 27.50 },
                { naam: 'Luxe buffet', prijs: 35.50 },
                { naam: 'Thema buffet', prijs: 42.50 }
            ]
        },
        club: {
            naam: 'Club arrangement',
            prijs: 45.00,
            opties: [
                { naam: 'Club basic (4 uur)', prijs: 45.00 },
                { naam: 'Club plus (5 uur)', prijs: 55.00 },
                { naam: 'Club deluxe (6 uur)', prijs: 65.00 }
            ]
        },
        drank: {
            naam: 'Drank arrangement',
            prijs: 15.00,
            opties: [
                { naam: 'Basis drank (2 uur)', prijs: 15.00 },
                { naam: 'Standaard drank (3 uur)', prijs: 20.00 },
                { naam: 'Onbeperkt drank (4 uur)', prijs: 25.00 }
            ]
        }
    });

    const [extraServices, setExtraServices] = useState([
        { id: 1, naam: 'DJ', prijs: 450, perPerson: false },
        { id: 2, naam: 'Bloemen decoratie', prijs: 175, perPerson: false },
        { id: 3, naam: 'Feest Decoratie', prijs: 175, perPerson: false },
        { id: 4, naam: 'Welkomstdrankje', prijs: 4.50, perPerson: true },
        { id: 5, naam: 'Late night snack', prijs: 3.75, perPerson: true },
        { id: 6, naam: 'VIP tafel', prijs: 150, perPerson: false },
        { id: 7, naam: 'Flessen sterke drank', prijs: 95, perPerson: false },
        { id: 8, naam: 'Club verlichting', prijs: 275, perPerson: false },
        { id: 9, naam: 'Confetti show', prijs: 125, perPerson: false }
    ]);

    const [locatieOpties, setLocatieOpties] = useState([
        { id: 'binnen', naam: 'Binnen', toeslag: 0 },
        { id: 'terras', naam: 'Terras', toeslag: 0 },
        { id: 'prive', naam: 'Privé ruimte', toeslag: 250 }
    ]);

    const [dietaryOpties, setDietaryOpties] = useState([
        { id: 'vegetarisch', naam: 'Vegetarisch', toeslag: 0 },
        { id: 'vegan', naam: 'Veganistisch', toeslag: 2.50 },
        { id: 'glutenvrij', naam: 'Glutenvrij', toeslag: 3 },
        { id: 'lactosevrij', naam: 'Lactosevrij', toeslag: 2 }
    ]);

    const [showPrijsEditor, setShowPrijsEditor] = useState(false);
    const [btwPercentage, setBtwPercentage] = useState(9);
    const [alertMessage, setAlertMessage] = useState('');
    const [voorwaarden, setVoorwaarden] = useState({
        minimumPersonen: 10,
        maximumPersonen: 200,
        aanbetaling: 25,
        annuleringsvoorwaarden: '48 uur van tevoren kosteloos'
    });

    const [emailTemplate, setEmailTemplate] = useState({
        onderwerp: 'Uw offerte voor [bedrijfsnaam]',
        aanhef: 'Geachte [contactpersoon],',
        tekst: 'Hierbij ontvangt u de offerte voor uw aanvraag.',
        afsluiting: 'Met vriendelijke groet,'
    });

    const validateForm = () => {
        const errors = [];
        if (!offerteData.bedrijfsnaam) errors.push('Bedrijfsnaam is verplicht');
        if (!offerteData.contactpersoon) errors.push('Contactpersoon is verplicht');
        if (!offerteData.email) errors.push('Email is verplicht');
        if (!offerteData.datum) errors.push('Datum is verplicht');
        if (!offerteData.aantalPersonen) errors.push('Aantal personen is verplicht');

        if (parseInt(offerteData.aantalPersonen) < voorwaarden.minimumPersonen) {
            errors.push(`Minimum aantal personen is ${voorwaarden.minimumPersonen}`);
        }
        if (parseInt(offerteData.aantalPersonen) > voorwaarden.maximumPersonen) {
            errors.push(`Maximum aantal personen is ${voorwaarden.maximumPersonen}`);
        }

        return errors;
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            if (name === 'dietaryWensen') {
                const updatedDietary = checked
                    ? [...offerteData.dietaryWensen, value]
                    : offerteData.dietaryWensen.filter(item => item !== value);
                setOfferteData(prev => ({ ...prev, dietaryWensen: updatedDietary }));
            } else if (name === 'extraServices') {
                const updatedServices = checked
                    ? [...offerteData.extraServices, value]
                    : offerteData.extraServices.filter(item => item !== value);
                setOfferteData(prev => ({ ...prev, extraServices: updatedServices }));
            }
        } else {
            setOfferteData(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleAddArrangement = () => {
        setOfferteData(prev => ({
            ...prev,
            arrangementen: [...prev.arrangementen, { type: 'lunch', optie: null }]
        }));
    };

    const handleArrangementChange = (index, field, value) => {
        const newArrangementen = [...offerteData.arrangementen];
        newArrangementen[index] = {
            ...newArrangementen[index],
            [field]: value
        };
        setOfferteData(prev => ({
            ...prev,
            arrangementen: newArrangementen
        }));
    };

    const handleRemoveArrangement = (index) => {
        setOfferteData(prev => ({
            ...prev,
            arrangementen: prev.arrangementen.filter((_, i) => i !== index)
        }));
    };

    const berekenTotaalprijs = () => {
        let basisprijs = 0;
        const aantalPersonen = Number(offerteData.aantalPersonen);

        offerteData.arrangementen.forEach(arrangement => {
            if (arrangement.optie) {
                basisprijs += arrangement.optie.prijs * aantalPersonen;
            } else {
                const defaultPrijs = prijslijst[arrangement.type].prijs;
                basisprijs += defaultPrijs * aantalPersonen;
            }
        });

        const locatieToeslag = locatieOpties.find(opt => opt.id === offerteData.locatie)?.toeslag || 0;
        basisprijs += locatieToeslag;

        const dietaryToeslag = offerteData.dietaryWensen.reduce((acc, dietary) => {
            const optie = dietaryOpties.find(opt => opt.id === dietary);
            return acc + (optie ? optie.toeslag * aantalPersonen : 0);
        }, 0);
        basisprijs += dietaryToeslag;

        const servicesToeslag = offerteData.extraServices.reduce((acc, service) => {
            const serviceOptie = extraServices.find(opt => opt.id.toString() === service);
            if (serviceOptie) {
                return acc + (serviceOptie.perPerson ? serviceOptie.prijs * aantalPersonen : serviceOptie.prijs);
            }
            return acc;
        }, 0);
        basisprijs += servicesToeslag;

        const btw = basisprijs * (btwPercentage / 100);
        const aanbetaling = (basisprijs + btw) * (voorwaarden.aanbetaling / 100);

        return {
            basisprijs: basisprijs.toFixed(2),
            btw: btw.toFixed(2),
            totaal: (basisprijs + btw).toFixed(2),
            aanbetaling: aanbetaling.toFixed(2)
        };
    };

    const generateCustomPDF = (offerteData, prijzen, voorwaarden, btwPercentage) => {
        const doc = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4'
        });

        const pageWidth = doc.internal.pageSize.getWidth();
        const margin = 20;

        const addCompanyLogo = () => {
            if (offerteData.logoData) {
                const logoWidth = 30;
                const logoHeight = 30;
                doc.addImage(offerteData.logoData, 'PNG', margin, margin, logoWidth, logoHeight);
            } else {
                doc.setFillColor(100, 100, 100);
                doc.rect(margin, margin, 25, 25, 'F');
                doc.setTextColor(255, 255, 255);
                doc.setFontSize(16);
                doc.text(offerteData.bedrijfsnaam.charAt(0), margin + 12.5, margin + 16, { align: 'center' });
                doc.setTextColor(0, 0, 0);
            }
        };

        addCompanyLogo();

        doc.setFontSize(20);
        doc.setFont('helvetica', 'bold');
        doc.text('OFFERTE', pageWidth - margin - 40, margin + 10);

        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        const currentDate = new Date().toLocaleDateString('nl-NL');
        const offerteNr = `OFF-${Date.now().toString().slice(-6)}`;
        doc.text(`Datum: ${currentDate}`, pageWidth - margin - 40, margin + 20);
        doc.text(`Offertenummer: ${offerteNr}`, pageWidth - margin - 40, margin + 25);

        doc.setDrawColor(200, 200, 200);
        doc.line(margin, margin + 35, pageWidth - margin, margin + 35);

        const colWidth = (pageWidth - (2 * margin) - 10) / 2;
        let yPos = margin + 45;

        doc.setFont('helvetica', 'bold');
        doc.text('Bedrijfsgegevens', margin, yPos);
        doc.setFont('helvetica', 'normal');
        yPos += 10;
        doc.text(`${offerteData.bedrijfsnaam}`, margin, yPos);
        yPos += 5;
        doc.text(`T.a.v. ${offerteData.contactpersoon}`, margin, yPos);
        yPos += 5;
        doc.text(`Tel: ${offerteData.telefoon}`, margin, yPos);
        yPos += 5;
        doc.text(`Email: ${offerteData.email}`, margin, yPos);

        yPos += 15;
        doc.setFont('helvetica', 'bold');
        doc.text('Reserveringsdetails', margin, yPos);
        doc.setFont('helvetica', 'normal');
        yPos += 10;
        doc.text(`Datum: ${offerteData.datum}`, margin, yPos);
        yPos += 5;
        doc.text(`Tijd: ${offerteData.begintijd} - ${offerteData.eindtijd}`, margin, yPos);
        yPos += 5;
        doc.text(`Aantal personen: ${offerteData.aantalPersonen}`, margin, yPos);
        yPos += 5;
        doc.text(`Locatie: ${offerteData.locatie}`, margin, yPos);

        let rightCol = pageWidth / 2 + 5;
        let rightYPos = margin + 45;

        doc.setFont('helvetica', 'bold');
        doc.text('Arrangementen', rightCol, rightYPos);
        doc.setFont('helvetica', 'normal');
        rightYPos += 10;
        offerteData.arrangementen.forEach((arrangement, index) => {
            const naam = arrangement.optie?.naam || prijslijst[arrangement.type].naam;
            const prijs = arrangement.optie?.prijs || prijslijst[arrangement.type].prijs;
            doc.text(`${index + 1}. ${naam} (€${prijs.toFixed(2)} p.p.)`, rightCol, rightYPos);
            rightYPos += 5;
        });

        if (offerteData.dietaryWensen.length > 0) {
            rightYPos += 15;
            doc.setFont('helvetica', 'bold');
            doc.text('Dietary wensen', rightCol, rightYPos);
            doc.setFont('helvetica', 'normal');
            rightYPos += 7;
            offerteData.dietaryWensen.forEach(wens => {
                const dietaryOptie = dietaryOpties.find(opt => opt.id === wens);
                if (dietaryOptie) {
                    doc.text(`• ${dietaryOptie.naam} (+€${dietaryOptie.toeslag.toFixed(2)} p.p.)`, rightCol, rightYPos);
                    rightYPos += 5;
                }
            });
        }

        if (offerteData.extraServices.length > 0) {
            rightYPos += 10;
            doc.setFont('helvetica', 'bold');
            doc.text('Extra services', rightCol, rightYPos);
            doc.setFont('helvetica', 'normal');
            rightYPos += 7;
            offerteData.extraServices.forEach(serviceId => {
                const service = extraServices.find(s => s.id.toString() === serviceId);
                if (service) {
                    const prijsText = service.perPerson
                        ? `€ ${service.prijs.toFixed(2)} p.p.`
                        : `€ ${service.prijs.toFixed(2)}`;
                    doc.text(`• ${service.naam} (${prijsText})`, rightCol, rightYPos);
                    rightYPos += 5;
                }
            });
        }

        if (offerteData.opmerkingen) {
            rightYPos += 10;
            doc.setFont('helvetica', 'bold');
            doc.text('Opmerkingen', rightCol, rightYPos);
            doc.setFont('helvetica', 'normal');
            rightYPos += 7;
            doc.text(offerteData.opmerkingen, rightCol, rightYPos, { maxWidth: colWidth });
            rightYPos += doc.splitTextToSize(offerteData.opmerkingen, colWidth).length * 5; // Aanpassen voor meerdere regels
        }

        if (offerteData.extraWensen) {
            rightYPos += 10;
            doc.setFont('helvetica', 'bold');
            doc.text('Extra wensen', rightCol, rightYPos);
            doc.setFont('helvetica', 'normal');
            rightYPos += 7;
            doc.text(offerteData.extraWensen, rightCol, rightYPos, { maxWidth: colWidth });
            rightYPos += doc.splitTextToSize(offerteData.extraWensen, colWidth).length * 5; // Aanpassen voor meerdere regels
        }

        const priceBoxY = Math.max(rightYPos + 10, 200); // Zorg dat prijsbox niet overlapt met inhoud
        doc.setDrawColor(200, 200, 200);
        doc.setFillColor(250, 250, 250);
        doc.rect(margin, priceBoxY, pageWidth - (2 * margin), 40, 'F');

        doc.setFont('helvetica', 'bold');
        doc.text('Prijsoverzicht', margin + 5, priceBoxY + 10);
        doc.setFont('helvetica', 'normal');
        doc.text(`Basisprijs:`, margin + 5, priceBoxY + 20);
        doc.text(`€ ${prijzen.basisprijs}`, margin + 50, priceBoxY + 20, { align: 'right' });
        doc.text(`BTW (${btwPercentage}%):`, margin + 5, priceBoxY + 27);
        doc.text(`€ ${prijzen.btw}`, margin + 50, priceBoxY + 27, { align: 'right' });
        doc.setFont('helvetica', 'bold');
        doc.text('Totaalbedrag:', margin + 5, priceBoxY + 35);
        doc.text(`€ ${prijzen.totaal}`, margin + 50, priceBoxY + 35, { align: 'right' });

        const footerY = priceBoxY + 50;
        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');
        doc.text(`• Aanbetaling ${voorwaarden.aanbetaling}% (€${prijzen.aanbetaling}) vereist bij reservering`, margin, footerY);
        doc.text(`• Annuleringsvoorwaarden: ${voorwaarden.annuleringsvoorwaarden}`, margin, footerY + 5);
        doc.text(`• Minimum aantal personen: ${voorwaarden.minimumPersonen}`, margin, footerY + 10);

        doc.save(`offerte-${offerteData.bedrijfsnaam}-${offerteData.datum}.pdf`);
    };

    const genereerPDF = () => {
        const errors = validateForm();
        if (errors.length > 0) {
            setAlertMessage(`Validatie fouten: ${errors.join(', ')}`);
            return;
        }

        const prijzen = berekenTotaalprijs();
        generateCustomPDF(offerteData, prijzen, voorwaarden, btwPercentage);
        toonAlert('PDF is succesvol gegenereerd!');
    };

    const verstuurEmail = () => {
        const emailContent = {
            to: offerteData.email,
            subject: emailTemplate.onderwerp.replace('[bedrijfsnaam]', offerteData.bedrijfsnaam),
            body: `${emailTemplate.aanhef.replace('[contactpersoon]', offerteData.contactpersoon)}\n\n${emailTemplate.tekst}\n\n${emailTemplate.afsluiting}`
        };

        console.log('Email verstuurd:', emailContent);
        toonAlert('Email is succesvol verstuurd!');
    };

    const toonAlert = (message) => {
        setAlertMessage(message);
        setTimeout(() => setAlertMessage(''), 3000);
    };

    return (
        <div className="container-fluid py-4" style={{ maxHeight: '100vh', overflowY: 'auto' }}>
            <div className="row">
                <div className="col-md-8">
                    <div className="card mb-4" style={{ height: ' спатьдcalc(100vh - 50px)' }}>
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h2 className="mb-0">Offerte Generator</h2>
                            <div>
                                <button className="btn btn-outline-secondary me-2" onClick={() => setShowPrijsEditor(true)}>
                                    Instellingen
                                </button>
                            </div>
                        </div>
                        <div className="card-body" style={{ overflowY: 'auto' }}>
                            {alertMessage && (
                                <div className="alert alert-info alert-dismissible fade show" role="alert">
                                    {alertMessage}
                                    <button type="button" className="btn-close" onClick={() => setAlertMessage('')}></button>
                                </div>
                            )}

                            <form>
                                <div className="mb-4">
                                    <h5 className="mb-3">Bedrijfsgegevens</h5>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Bedrijfsnaam</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="bedrijfsnaam"
                                                value={offerteData.bedrijfsnaam}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Contactpersoon</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="contactpersoon"
                                                value={offerteData.contactpersoon}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Email</label>
                                            <input
                                                type="email"
                                                className="form-control"
                                                name="email"
                                                value={offerteData.email}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Telefoon</label>
                                            <input
                                                type="tel"
                                                className="form-control"
                                                name="telefoon"
                                                value={offerteData.telefoon}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <h5 className="mb-3">Reserveringsdetails</h5>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Datum</label>
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="datum"
                                                value={offerteData.datum}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Begintijd</label>
                                            <input
                                                type="time"
                                                className="form-control"
                                                name="begintijd"
                                                value={offerteData.begintijd}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Eindtijd</label>
                                            <input
                                                type="time"
                                                className="form-control"
                                                name="eindtijd"
                                                value={offerteData.eindtijd}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Aantal personen</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="aantalPersonen"
                                                value={offerteData.aantalPersonen}
                                                onChange={handleInputChange}
                                                min={voorwaarden.minimumPersonen}
                                                max={voorwaarden.maximumPersonen}
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">Locatie</label>
                                            <select
                                                className="form-select"
                                                name="locatie"
                                                value={offerteData.locatie}
                                                onChange={handleInputChange}
                                            >
                                                {locatieOpties.map(optie => (
                                                    <option key={optie.id} value={optie.id}>
                                                        {optie.naam} {optie.toeslag > 0 ? `(+€${optie.toeslag})` : ''}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <h5 className="mb-3">Arrangementen</h5>
                                    {offerteData.arrangementen.map((arrangement, index) => (
                                        <div key={index} className="card mb-3">
                                            <div className="card-body">
                                                <div className="row">
                                                    <div className="col-md-5 mb-3">
                                                        <label className="form-label">Type arrangement</label>
                                                        <select
                                                            className="form-select"
                                                            value={arrangement.type}
                                                            onChange={(e) => handleArrangementChange(index, 'type', e.target.value)}
                                                        >
                                                            {Object.entries(prijslijst).map(([key, value]) => (
                                                                <option key={key} value={key}>{value.naam}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-5 mb-3">
                                                        <label className="form-label">Opties</label>
                                                        <select
                                                            className="form-select"
                                                            value={arrangement.optie?.naam || ''}
                                                            onChange={(e) => {
                                                                const selectedOptie = prijslijst[arrangement.type].opties.find(opt => opt.naam === e.target.value);
                                                                handleArrangementChange(index, 'optie', selectedOptie);
                                                            }}
                                                        >
                                                            <option value="">Selecteer een optie</option>
                                                            {prijslijst[arrangement.type].opties.map((optie, i) => (
                                                                <option key={i} value={optie.naam}>
                                                                    {optie.naam} - €{optie.prijs.toFixed(2)} p.p.
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-md-2 d-flex align-items-end">
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger w-100"
                                                            onClick={() => handleRemoveArrangement(index)}
                                                            disabled={offerteData.arrangementen.length === 1}
                                                        >
                                                            X
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary"
                                        onClick={handleAddArrangement}
                                    >
                                        Arrangement toevoegen
                                    </button>
                                </div>

                                <div className="mb-4">
                                    <h5 className="mb-3">Dieët wensen</h5>
                                    <div className="row">
                                        {dietaryOpties.map(optie => (
                                            <div key={optie.id} className="col-md-6 mb-2">
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id={`dietary-${optie.id}`}
                                                        name="dietaryWensen"
                                                        value={optie.id}
                                                        checked={offerteData.dietaryWensen.includes(optie.id)}
                                                        onChange={handleInputChange}
                                                    />
                                                    <label className="form-check-label" htmlFor={`dietary-${optie.id}`}>
                                                        {optie.naam} {optie.toeslag > 0 ? `(+€${optie.toeslag} p.p.)` : ''}
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <h5 className="mb-3">Extra services</h5>
                                    <div className="row">
                                        {extraServices.map(service => (
                                            <div key={service.id} className="col-md-6 mb-2">
                                                <div className="form-check">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        id={`service-${service.id}`}
                                                        name="extraServices"
                                                        value={service.id}
                                                        checked={offerteData.extraServices.includes(service.id.toString())}
                                                        onChange={handleInputChange}
                                                    />
                                                    <label className="form-check-label" htmlFor={`service-${service.id}`}>
                                                        {service.naam} (€{service.prijs.toFixed(2)} {service.perPerson ? 'p.p.' : ''})
                                                    </label>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <h5 className="mb-3">Extra wensen</h5>
                                    <textarea
                                        className="form-control"
                                        name="extraWensen"
                                        value={offerteData.extraWensen}
                                        onChange={handleInputChange}
                                        rows="4"
                                        placeholder="Voer hier eventuele extra wensen in..."
                                    />
                                </div>

                                <div className="mb-4">
                                    <h5 className="mb-3">Opmerkingen</h5>
                                    <textarea
                                        className="form-control"
                                        name="opmerkingen"
                                        value={offerteData.opmerkingen}
                                        onChange={handleInputChange}
                                        rows="3"
                                        placeholder="Eventuele opmerkingen..."
                                    />
                                </div>

                                <div className="mb-4">
                                    <h5 className="mb-3">Prijsoverzicht</h5>
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <p className="mb-2">Basisprijs: €{berekenTotaalprijs().basisprijs}</p>
                                                    <p className="mb-2">BTW ({btwPercentage}%): €{berekenTotaalprijs().btw}</p>
                                                </div>
                                                <div className="col-md-6">
                                                    <p className="mb-2">Totaalprijs: €{berekenTotaalprijs().totaal}</p>
                                                    <p className="mb-2">Aanbetaling ({voorwaarden.aanbetaling}%): €{berekenTotaalprijs().aanbetaling}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex justify-content-end gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={genereerPDF}
                                    >
                                        Genereer PDF
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div className={`modal ${showPrijsEditor ? 'show d-block' : ''}`} tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Instellingen</h5>
                                <button type="button" className="btn-close" onClick={() => setShowPrijsEditor(false)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-4">
                                    <h6 className="mb-3">BTW & Algemene Instellingen</h6>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label className="form-label">BTW percentage</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={btwPercentage}
                                                onChange={(e) => setBtwPercentage(Number(e.target.value))}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Minimum personen</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={voorwaarden.minimumPersonen}
                                                onChange={(e) => setVoorwaarden(prev => ({ ...prev, minimumPersonen: Number(e.target.value) }))}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">Maximum personen</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={voorwaarden.maximumPersonen}
                                                onChange={(e) => setVoorwaarden(prev => ({ ...prev, maximumPersonen: Number(e.target.value) }))}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <h6 className="mb-3">Arrangement Prijzen</h6>
                                    {Object.entries(prijslijst).map(([key, arrangement]) => (
                                        <div key={key} className="card mb-3">
                                            <div className="card-header">
                                                <h6 className="mb-0">{arrangement.naam}</h6>
                                            </div>
                                            <div className="card-body">
                                                <div className="row">
                                                    {arrangement.opties.map((optie, index) => (
                                                        <div key={index} className="col-md-4 mb-3">
                                                            <label className="form-label">{optie.naam}</label>
                                                            <div className="input-group">
                                                                <span className="input-group-text">€</span>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    value={optie.prijs}
                                                                    onChange={(e) => {
                                                                        const newPrijslijst = { ...prijslijst };
                                                                        newPrijslijst[key].opties[index].prijs = Number(e.target.value);
                                                                        setPrijslijst(newPrijslijst);
                                                                    }}
                                                                    step="0.10"
                                                                />
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="mb-4">
                                    <h6 className="mb-3">Locatie Toeslagen</h6>
                                    <div className="row">
                                        {locatieOpties.map((locatie) => (
                                            <div key={locatie.id} className="col-md-4 mb-3">
                                                <label className="form-label">{locatie.naam}</label>
                                                <div className="input-group">
                                                    <span className="input-group-text">€</span>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={locatie.toeslag}
                                                        onChange={(e) => {
                                                            const newLocaties = locatieOpties.map(l =>
                                                                l.id === locatie.id ? { ...l, toeslag: Number(e.target.value) } : l
                                                            );
                                                            setLocatieOpties(newLocaties);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <h6 className="mb-3">Dieët Toeslagen (per persoon)</h6>
                                    <div className="row">
                                        {dietaryOpties.map((optie) => (
                                            <div key={optie.id} className="col-md-3 mb-3">
                                                <label className="form-label">{optie.naam}</label>
                                                <div className="input-group">
                                                    <span className="input-group-text">€</span>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={optie.toeslag}
                                                        onChange={(e) => {
                                                            const newOpties = dietaryOpties.map(o =>
                                                                o.id === optie.id ? { ...o, toeslag: Number(e.target.value) } : o
                                                            );
                                                            setDietaryOpties(newOpties);
                                                        }}
                                                        step="0.10"
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <h6 className="mb-3">Extra Services</h6>
                                    <div className="row">
                                        {extraServices.map((service) => (
                                            <div key={service.id} className="col-md-6 mb-3">
                                                <div className="card">
                                                    <div className="card-body">
                                                        <label className="form-label">{service.naam}</label>
                                                        <div className="input-group mb-2">
                                                            <span className="input-group-text">€</span>
                                                            <input
                                                                type="number"
                                                                className="form-control"
                                                                value={service.prijs}
                                                                onChange={(e) => {
                                                                    const newServices = extraServices.map(s =>
                                                                        s.id === service.id ? { ...s, prijs: Number(e.target.value) } : s
                                                                    );
                                                                    setExtraServices(newServices);
                                                                }}
                                                                step="0.10"
                                                            />
                                                        </div>
                                                        <div className="form-check">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                checked={service.perPerson}
                                                                onChange={(e) => {
                                                                    const newServices = extraServices.map(s =>
                                                                        s.id === service.id ? { ...s, perPerson: e.target.checked } : s
                                                                    );
                                                                    setExtraServices(newServices);
                                                                }}
                                                            />
                                                            <label className="form-check-label">Prijs per persoon</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowPrijsEditor(false)}>Sluiten</button>
                                <button type="button" className="btn btn-primary" onClick={() => setShowPrijsEditor(false)}>Opslaan</button>
                            </div>
                        </div>
                    </div>
                </div>
                {showPrijsEditor && <div className="modal-backdrop fade show"></div>}
            </div>
        </div>
    );
};

export default OfferteGenerator1;
